import '@/assets/vendor/nucleo/css/nucleo.css';
import '@/assets/scss/argon.scss';
import globalComponents from './globalComponents';
import globalDirectives from './globalDirectives';
import { BootstrapVue } from 'bootstrap-vue'
import SidebarPlugin from '@/components/template/SidebarPlugin/index';
import NotificationPlugin from '@/components/template/NotificationPlugin/index';

export default {
  install(Vue) {
    Vue.use(globalComponents);
    Vue.use(globalDirectives);
    Vue.use(SidebarPlugin);
    Vue.use(NotificationPlugin);
    Vue.use(BootstrapVue)
  }
};



// WEBPACK FOOTER //
// ./src/plugins/argon-dashboard.js